import styled from 'styled-components'

import bgImg from '@/assets/images/login.png'

export const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #fdfcf9;
`

export const PayWrapper = styled.div`
  max-width: 1000px;
  margin: 60px auto;
  padding: 40px;
  display: flex;
  height: 480px;
`

export const LeftSection = styled.div`
  width: 470px;
  background: white;
  padding: 40px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const RightSection = styled.div`
  width: 370px;
  background: #2b2d5b;
  padding: 40px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  color: white;
  position: relative;
  overflow: hidden;
  background-image: url(${bgImg});
  background-repeat: no-repeat;
  background-size: cover;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }
`

export const Logo = styled.div`
  width: 48px;
  height: 48px;
  margin-bottom: 32px;

  img {
    width: 100%;
    height: 100%;
  }
`

export const Title = styled.h1`
  color: var(--Grays-Black, #07091e);
  text-align: center;
  font-family: Rubik;
  font-size: 34px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const Subtitle = styled.p`
  font-size: 16px;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--Grays-Gray-3, #777e90);
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  span {
    color: var(--Brand, #ff763c);
    text-align: center;
    font-family: Rubik;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding-right: 4px;
  }
`

export const GoogleButton = styled.button`
  width: 100%;
  padding: 12px;
  background: #2b2d5b;
  color: white;
  border: none;
  border-radius: 32px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  img {
    width: 20px;
    height: 20px;
    filter: brightness(0) invert(1);
  }

  &:hover {
    background: var(--Btn, radial-gradient(37.99% 44.11% at 50% 100%, #ffc13c 0%, #ff763c 100%));
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
`

export const Terms = styled.p`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 24px;
  text-align: center;

  a {
    color: #4285f4;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`

export const Footer = styled.footer`
  width: 100%;
  padding: 20px;
  text-align: center;
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;

  a {
    color: #4285f4;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`

export const ChartContainer = styled.div`
  position: relative;
  z-index: 1;
  margin-bottom: 40px;
`

export const Chart = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  height: 200px;
  margin-bottom: 20px;
`

export const Bar = styled.div<{ height: number; color: string }>`
  width: 24px;
  height: ${(props) => props.height}%;
  background: ${(props) => props.color};
  border-radius: 12px;
  transition: height 0.3s ease;
`

export const ChartIcon = styled.div`
  position: absolute;
  bottom: -20px;
  right: -20px;
  width: 40px;
  height: 40px;
  background: #ff6b00;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 24px;
    height: 24px;
    filter: brightness(0) invert(1);
  }
`
